import type { BlockContentAndBanner } from 'types/block-content-and-banner';
import React from 'react';
import { Wrap } from '@leafwell/components';
import HeadingBody from './heading-body';
import WysiwygContent from './wysiwyg-content';
import Figure from './figure';

const ContentAndBanner: React.FC<BlockContentAndBanner> = ({
  sectionId,
  title,
  contentRight,
  contentLeft,
  bannerTitle,
  bannerLabel,
  bannerImage,
}) => {
  const hasContent = contentRight?.length > 0 || contentLeft?.length > 0;

  return (
    <section
      id={sectionId}
      className="my-10 md:my-12 lg:mt-12 bg-[#FFFAF8] border border-gray-200"
    >
      <Wrap className="!pb-0">
        {title?.length > 0 && (
          <HeadingBody
            className="text-center lg:text-left"
            level="2"
            title={title}
          />
        )}
        {hasContent ? (
          <div className="grid lg:grid-cols-2 lg:gap-x-14 lg:items-baseline">
            {contentLeft?.length > 0 && (
              <WysiwygContent content={contentLeft} className="flex flex-col" />
            )}
            {contentRight?.length > 0 && (
              <WysiwygContent
                content={contentRight}
                className="lg:max-w-lg lg:justify-self-end"
              />
            )}
          </div>
        ) : null}
        <div
          className={[
            'grid gap-y-10',
            hasContent ? 'lg:grid-cols-2' : 'justify-items-center',
          ].join(' ')}
        >
          <div
            className={hasContent ? 'text-center lg:text-left' : 'text-center'}
          >
            {bannerTitle?.length > 0 && (
              <HeadingBody
                className="!mb-2"
                tagName="p"
                level="2"
                title={bannerTitle}
              />
            )}
            {bannerLabel?.length > 0 ? (
              <p
                className={['mt-4', hasContent ? 'lg:max-w-sm' : ''].join(' ')}
              >
                {bannerLabel}
              </p>
            ) : null}
          </div>
          {bannerImage && (
            <div
              className={[
                hasContent ? 'flex justify-center lg:justify-end' : '',
              ].join(' ')}
            >
              <Figure {...bannerImage} className="max-w-lg" />
            </div>
          )}
        </div>
      </Wrap>
    </section>
  );
};

export default ContentAndBanner;
